import styled from 'styled-components';
import { ThemeInterface } from '../../interfaces/themeInterface';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background: ${({ theme }: { theme: ThemeInterface }) => theme.background};
  border-radius: 8px;
  min-width: 200px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const Title = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }: { theme: ThemeInterface }) => theme.text};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const ToggleButton = styled.button<{ $isActive: boolean }>`
  border: none;
  background: ${({ $isActive, theme }: { $isActive: boolean; theme: ThemeInterface }) =>
    $isActive ? theme.accent || '#4CAF50' : theme.secondary || '#333'};
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  color: ${({ theme }: { theme: ThemeInterface }) => theme.text};
  font-size: 11px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.85;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const Controls = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ControlRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Label = styled.label`
  font-size: 11px;
  color: ${({ theme }: { theme: ThemeInterface }) => theme.text};
  opacity: 0.7;
  min-width: 50px;
`;

export const VolumeSlider = styled.input`
  flex: 1;
  height: 4px;
  appearance: none;
  background: ${({ theme }: { theme: ThemeInterface }) => theme.secondary || '#333'};
  border-radius: 2px;
  cursor: pointer;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 12px;
    height: 12px;
    background: ${({ theme }: { theme: ThemeInterface }) => theme.accent || '#4CAF50'};
    border-radius: 50%;
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: 12px;
    height: 12px;
    background: ${({ theme }: { theme: ThemeInterface }) => theme.accent || '#4CAF50'};
    border-radius: 50%;
    cursor: pointer;
    border: none;
  }
`;

export const ModeSelect = styled.select`
  flex: 1;
  padding: 6px 8px;
  background: ${({ theme }: { theme: ThemeInterface }) => theme.secondary || '#333'};
  color: ${({ theme }: { theme: ThemeInterface }) => theme.text};
  border: none;
  border-radius: 4px;
  font-size: 11px;
  cursor: pointer;
  outline: none;

  &:focus {
    outline: 1px solid ${({ theme }: { theme: ThemeInterface }) => theme.accent || '#4CAF50'};
  }
`;

export const TickCounter = styled.div`
  font-size: 10px;
  color: ${({ theme }: { theme: ThemeInterface }) => theme.text};
  opacity: 0.5;
  text-align: right;
  font-family: monospace;
`;

export const VolumeValue = styled.span`
  font-size: 10px;
  color: ${({ theme }: { theme: ThemeInterface }) => theme.text};
  opacity: 0.6;
  min-width: 30px;
  text-align: right;
  font-family: monospace;
`;
